import angular from 'angular';

var pollsServices = angular.module('applicationModule.pollsServices', []);

pollsServices.factory('Polls', ['PollsAPI', function (PollsAPI) {
    'use strict';

    return {
        getList: function (appId, params) {
            return PollsAPI.getList(appId, params)
                .then(function (response) {
                    return response.data;
                });
        },
        get: function (id, appId) {
            return PollsAPI.get(id, appId);
        },
        save: function (poll, editMode) {
            if (editMode) {
                return PollsAPI.edit(poll);
            } else {
                return PollsAPI.create(poll);
            }
        },
        remove: function (id, appId) {
            return PollsAPI.remove(id, appId);
        },
        generateCSV: function (appId, pollId) {
            return PollsAPI.generateCSV(appId, pollId);
        },
        copy: function (pollId) {
            return PollsAPI.copy(pollId);
        }
    };
}]);

pollsServices.service('PollsAPI', ['$http', 'AppsoupAPI', function ($http, AppsoupAPI) {
    'use strict';

    var API_URL = AppsoupAPI.API_URL + '/app/poll/';

    this.getList = function (appId, params) {
        return $http.get(API_URL, {params: angular.extend(AppsoupAPI.getTableParams(params), {app_id: appId})});
    };

    this.create = function (poll) {
        return $http.post(API_URL + 'create', poll);
    };
    this.get = function (id, appId) {
        return $http.get(API_URL + id + '/' + appId);
    };

    this.edit = function (poll) {
        return $http.put(API_URL + 'update/' + poll.id, poll);
    };

    this.remove = function (id, appId) {
        return $http.delete(API_URL + 'delete/' + id + '/' + appId);
    };

    this.generateCSV = function (appId, pollId) {
        return $http.post(API_URL + 'report/', {application_id: appId, poll_id: pollId});
    };

    this.copy = function (pollId) {
        return $http.get(API_URL + 'copy/' + pollId);
    };
}]);

pollsServices.factory('PollElements', ['PollElementsAPI', function (PollElementsAPI) {
    'use strict';

    return {
        getList: function (appId, formId, params) {
            return PollElementsAPI.getList(appId, formId, params);
        },
        get: function (id, appId) {
            return PollElementsAPI.get(id, appId);
        },
        save: function (element, editMode) {
            if (editMode) {
                return PollElementsAPI.edit(element);
            } else {
                return PollElementsAPI.store(element);
            }
        },
        saveOption: function (option) {
            return PollElementsAPI.saveOption(option);
        },
        remove: function (id, appId) {
            return PollElementsAPI.remove(id, appId);
        },
        removeOption: function (id, elementId) {
            return PollElementsAPI.removeOption(id, elementId);
        },
        changeOrder: function (data) {
            return PollElementsAPI.changeOrder(data);
        },
        changeOptionOrder: function (data) {
            return PollElementsAPI.changeOptionOrder(data);
        },
        create: function (appId, editMode, id, pollId) {
            return PollElementsAPI.create(appId, editMode, id, pollId);
        },
        checkCorrectAnswer: function (elementId, optionId) {
            return PollElementsAPI.checkCorrectAnswer(elementId, optionId);
        }
    };
}]);

pollsServices.service('PollElementsAPI', ['$http', 'AppsoupAPI', function ($http, AppsoupAPI) {
    'use strict';

    var API_URL = AppsoupAPI.API_URL + '/app/poll-element/';

    this.getList = function (appId, pollId, params) {
        return $http.get(API_URL, {
            params: angular.extend(AppsoupAPI.getTableParams(params), {
                app_id: appId,
                poll_id: pollId
            })
        });
    };

    this.store = function (element) {
        return $http.post(API_URL + 'store', element);
    };

    this.saveOption = function (option) {
        return $http.post(API_URL + 'save-option', option);
    };

    this.get = function (id, appId) {
        return $http.get(API_URL + id + '/' + appId);
    };

    this.edit = function (element) {
        return $http.put(API_URL + 'update/' + element.id, element);
    };

    this.remove = function (id, appId) {
        return $http.delete(API_URL + 'delete/' + id + '/' + appId);
    };

    this.removeOption = function (id, elementId) {
        return $http.delete(API_URL + 'delete-option/' + id + '/' + elementId);
    };

    this.changeOrder = function (data) {
        var url = API_URL + 'change-order/';

        return $http.post(url, data);
    };

    this.changeOptionOrder = function (data) {
        var url = API_URL + 'change-order-option/';

        return $http.post(url, data);
    };

    this.create = function (appId, editMode, id, pollId) {
        return $http.get(API_URL + 'create', {
            params: {
                application_id: appId,
                edit_mode: editMode,
                poll_id: pollId,
                id: id
            }
        });
    };

    this.checkCorrectAnswer = function (elementId, optionId) {
        return $http.get(API_URL + 'check-correct-answer/' + elementId + '/' + optionId);
    };

}]);

pollsServices.factory('PollResults', ['PollResultsAPI', function (PollResultsAPI) {
    'use strict';

    return {
        getList: function (appId, pollId, params) {
            return PollResultsAPI.getList(appId, pollId, params)
                .then(function (response) {
                    return response.data;
                });
        },
        get: function (id, appId) {
            return PollResultsAPI.get(id, appId);
        },
        save: function (result, editMode) {
            if (editMode) {
                return PollResultsAPI.edit(result);
            } else {
                return PollResultsAPI.store(result);
            }
        },
        remove: function (id, appId) {
            return PollResultsAPI.remove(id, appId);
        }
    };
}]);

pollsServices.service('PollResultsAPI', ['$http', 'AppsoupAPI', function ($http, AppsoupAPI) {
    'use strict';

    var API_URL = AppsoupAPI.API_URL + '/app/poll-results/';

    this.getList = function (appId, pollId, params) {
        return $http.get(API_URL, {
            params: angular.extend(AppsoupAPI.getTableParams(params), {
                app_id: appId,
                poll_id: pollId
            })
        });
    };

    this.store = function (result) {
        return $http.post(API_URL, result);
    };

    this.get = function (id, appId) {
        return $http.get(API_URL + id, {params: {app_id: appId}});
    };

    this.edit = function (result) {
        return $http.put(API_URL + 'update/' + result.id, result);
    };

    this.remove = function (id) {
        return $http.delete(API_URL + id);
    };

}]);


export default pollsServices;
